export default __webpack_public_path__ + "static/media/9.b7a31d47.svg";